import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import {InputBase, Paper, Divider} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';

const AddTxtField = (props) => {
    const {label, action, txt, setTxt} = props;
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            action();
        }
    }
    return (<Paper
        component="form"
        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', }}
    >
        <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder={label}
            inputProps={{ 'aria-label': label }}
            onKeyPress={handleKeyPress}
            value={txt}
            onChange={(e) => setTxt(e.target.value)}
        />
        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
        <IconButton color="inherit" sx={{ p: '10px' }} aria-label="directions" onClick={action}>
            <AddIcon />
        </IconButton>
    </Paper>);
}

export default AddTxtField